export const CounterItemsArray = [
  {
    title: "Satisfied Clients",
    amount: 44,
    icon: (
      <>
        <svg viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M32.5 40.6251C42.5965 40.6251 50.7812 32.7434 50.7812 23.0209C50.7812 13.2984 42.5965 5.41675 32.5 5.41675C22.4035 5.41675 14.2188 13.2984 14.2188 23.0209C14.2188 32.7434 22.4035 40.6251 32.5 40.6251Z"
            stroke="currentcolor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.3666 36.6164L20.3396 56.6039C20.3396 59.0414 22.0459 60.2331 24.1584 59.231L31.4167 55.7914C32.0125 55.4935 33.0146 55.4935 33.6104 55.7914L40.8959 59.231C42.9813 60.206 44.7146 59.0414 44.7146 56.6039V36.1289"
            stroke="currentcolor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    title: "Active Request",
    amount: 1,
    icon: (
      <>
        <svg viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M33.4999 28.4495V35.2744C33.4999 40.9744 31.2249 43.2494 25.5249 43.2494H18.725C13.05 43.2494 10.75 40.9744 10.75 35.2744V28.4495C10.75 22.7745 13.025 20.4995 18.725 20.4995H25.5499C31.2249 20.4995 33.4999 22.7745 33.4999 28.4495Z"
            stroke="currentcolor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M43.2498 18.6997V25.5247C43.2498 31.2246 40.9748 33.4996 35.2748 33.4996H33.4998V28.4497C33.4998 22.7747 31.2248 20.4997 25.5249 20.4997H20.4999V18.6997C20.4999 12.9997 22.7749 10.7498 28.4748 10.7498H35.2998C40.9748 10.7498 43.2498 13.0247 43.2498 18.6997Z"
            stroke="currentcolor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.9997 34.5002C51.9997 44.1752 44.1748 52.0001 34.4998 52.0001L37.1248 47.6252"
            stroke="currentcolor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 19.4999C2 9.82496 9.82496 2 19.4999 2L16.8749 6.37498"
            stroke="currentcolor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </>
    ),
  },
  {
    title: "Winning Award",
    amount: 8,
    icon: (
      <>
        <svg viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.125 1.35417C8.125 0.995019 8.26767 0.650582 8.52163 0.396626C8.77558 0.142671 9.12002 0 9.47917 0H39.2708C39.63 0 39.9744 0.142671 40.2284 0.396626C40.4823 0.650582 40.625 0.995019 40.625 1.35417V2.70833H47.3958C47.755 2.70833 48.0994 2.851 48.3534 3.10496C48.6073 3.35892 48.75 3.70335 48.75 4.0625V12.1875C48.75 13.9832 48.0366 15.7054 46.7669 16.9752C45.4971 18.245 43.7749 18.9583 41.9792 18.9583H39.7001C37.6133 24.8625 32.2116 29.2012 25.7292 29.7361V37.9167H35.2083C35.5675 37.9167 35.9119 38.0593 36.1659 38.3133C36.4198 38.5672 36.5625 38.9117 36.5625 39.2708V47.3958C36.5625 47.755 36.4198 48.0994 36.1659 48.3534C35.9119 48.6073 35.5675 48.75 35.2083 48.75H13.5417C13.1825 48.75 12.8381 48.6073 12.5841 48.3534C12.3302 48.0994 12.1875 47.755 12.1875 47.3958V39.2708C12.1875 38.9117 12.3302 38.5672 12.5841 38.3133C12.8381 38.0593 13.1825 37.9167 13.5417 37.9167H23.0208V29.7361C16.5398 29.2012 11.1367 24.8625 9.0499 18.9583H6.77083C4.9751 18.9583 3.25291 18.245 1.98313 16.9752C0.713354 15.7054 0 13.9832 0 12.1875V4.0625C0 3.70335 0.142671 3.35892 0.396626 3.10496C0.650582 2.851 0.995019 2.70833 1.35417 2.70833H8.125V1.35417ZM37.9167 13.5417V2.70833H10.8333V13.5417C10.8333 21.0207 16.8959 27.0833 24.375 27.0833C31.8541 27.0833 37.9167 21.0207 37.9167 13.5417ZM40.625 5.41667V16.25H41.9792C43.0566 16.25 44.0899 15.822 44.8518 15.0601C45.6137 14.2983 46.0417 13.2649 46.0417 12.1875V5.41667H40.625ZM2.70833 5.41667H8.125V16.25H6.77083C5.69339 16.25 4.66008 15.822 3.89821 15.0601C3.13634 14.2983 2.70833 13.2649 2.70833 12.1875V5.41667ZM14.8958 40.625V46.0417H33.8542V40.625H14.8958Z"
            fill="currentcolor"
          />
        </svg>
      </>
    ),
  },
  {
    title: "Expert Teams",
    amount: 1,
    icon: (
      <>
        <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M44.9999 17.9C44.8499 17.875 44.6749 17.875 44.5249 17.9C41.0749 17.775 38.3249 14.95 38.3249 11.45C38.3249 7.875 41.1999 5 44.7749 5C48.3499 5 51.2249 7.9 51.2249 11.45C51.1999 14.95 48.4499 17.775 44.9999 17.9Z"
            stroke="currentcolor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.4249 36.0999C45.8499 36.6749 49.6249 36.0749 52.2749 34.2999C55.7999 31.9499 55.7999 28.0999 52.2749 25.7499C49.5999 23.9749 45.7749 23.3749 42.3499 23.9749"
            stroke="currentcolor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.9248 17.9C15.0748 17.875 15.2498 17.875 15.3998 17.9C18.8498 17.775 21.5998 14.95 21.5998 11.45C21.5998 7.875 18.7248 5 15.1498 5C11.5748 5 8.69983 7.9 8.69983 11.45C8.72483 14.95 11.4748 17.775 14.9248 17.9Z"
            stroke="currentcolor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.4998 36.0999C14.0748 36.6749 10.2999 36.0749 7.64985 34.2999C4.12485 31.9499 4.12485 28.0999 7.64985 25.7499C10.3249 23.9749 14.1498 23.3749 17.5748 23.9749"
            stroke="currentcolor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.9999 36.5748C29.8499 36.5498 29.6749 36.5498 29.5249 36.5748C26.0749 36.4498 23.3249 33.6248 23.3249 30.1248C23.3249 26.5498 26.1999 23.6748 29.7749 23.6748C33.3499 23.6748 36.2249 26.5748 36.2249 30.1248C36.1999 33.6248 33.4499 36.4748 29.9999 36.5748Z"
            stroke="currentcolor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.7249 44.4497C19.1999 46.7997 19.1999 50.6497 22.7249 52.9997C26.7249 55.6747 33.2749 55.6747 37.2749 52.9997C40.7999 50.6497 40.7999 46.7997 37.2749 44.4497C33.2999 41.7997 26.7249 41.7997 22.7249 44.4497Z"
            stroke="currentcolor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </>
    ),
  },
];
